import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { RESET_APP } from './actions';
import app from './slices/appSlice';
import auth from './slices/authSlice';
import financialCalculator from './slices/financialCalculatorSlice';
import legalNote from './slices/legalNoteSlice';
import services from './slices/servicesSlice';

const appReducer = combineReducers({
  app,
  auth,
  financialCalculator,
  legalNote,
  services
});

const rootReducer = (state: any, action: any) => {
  if (action.type === RESET_APP) {
    state = undefined;
  }
  return appReducer(state, action);
};

export const store = configureStore({
  devTools: !process.env.REACT_APP_DISABLE_REDUX_DEV_TOOLS,
  reducer: rootReducer
});

export const setupStoreTesting: (preloadedState?: any) => any = (
  preloadedState
) =>
  configureStore({
    preloadedState,
    reducer: rootReducer
  });

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
